import EventEmitter from 'eventemitter3'
import type * as Types from 'src/api/types'

interface AuthEventTypes {
  readonly ACCESS_TOKEN_FAILED: [Types.AuthObject]
  readonly GOOGLE_TOKEN_RESPONSE: [google.accounts.oauth2.TokenResponse]
}

export const authEventEmitter = new EventEmitter<AuthEventTypes>()
